import { useEffect, useState } from "react";

export const ProgressCircle = ({ percentage }) => {
    const [animatedPercent, setAnimatedPercent] = useState(0);
    useEffect(() => {
        const timer = setTimeout(() => {
            setAnimatedPercent(percentage);
        }, 50);

        return () => clearTimeout(timer);
    }, [percentage]);
    return (
        <>
            <div className="progress-wrapper">
                <div className="progress-circle" style={{ "--percent": animatedPercent }}>
                    <svg className="svg-circle" viewBox="0 0 100 100">
                        <circle className="bg-circle" cx="50" cy="50" r="36" />
                        <circle className="progress-circle-path" cx="50" cy="50" r="36" />
                    </svg>

                    <div className="progress-text">{percentage?.toFixed(0) || 0}%</div>
                </div>
            </div>

            <style jsx>{`
           .progress-wrapper {
             display: flex;
             justify-content: center;
             align-items: center;
           }
   
           .progress-circle {
             position: relative;
             width: 35px;
             height: 35px;
             --circumference: 226.2;
             --percent: 0;
           }
   
           .svg-circle {
             width: 100%;
             height: 100%;
             transform: rotate(-90deg);
           }
   
           .bg-circle {
             fill: none;
             stroke: #c8c6c6;
             stroke-width: 12;
           }
   
           .progress-circle-path {
             fill: none;
             stroke: #7a3a5e;
             stroke-width: 12;
             stroke-linecap: round;
             stroke-dasharray: var(--circumference);
             stroke-dashoffset: calc(
               var(--circumference) -
               (var(--percent) / 100 * var(--circumference))
             );
             transition: stroke-dashoffset 2s cubic-bezier(0.2, 0, 0.2, 1);
           }
   
           .progress-text {
             position: absolute;
             top: 50%;
             left: 50%;
             transform: translate(-50%, -50%);
             font-size: 6px;
             font-weight: 600;
           }
         `}</style>
        </>
    );
};